import {FilterMatchMode, FilterOperator} from "primereact/api";
import {AUDIO_LOADING, UPLOAD_AUDIO_LOADING, CLEAR_ALL_STATES} from "../types/types";
import {
    CLEAR_STATISTICS_FILTERS, GET_FILES_HISTORY,
    GET_STATISTIC,
    GET_STATISTICS, GET_STATISTICS_FILES_PAGINATION,
    GET_STATISTICS_PAGINATION,
    HIDE_LOADER,
    INITIAL_STATISTICS_DATA,
    SELECTED_STATISTICS_ID, SET_CURRENT_STATISTICS_FILES_PAGE, SET_CURRENT_STATISTICS_FILES_SIZE,
    SET_CURRENT_STATISTICS_PAGE,
    SET_CURRENT_STATISTICS_SIZE, SET_FILES_HISTORY_LOADER, SET_FIRST_PAGE,
    SET_RATED_QUESTIONNAIRES, GET_STATISTIC_DASHBOARD, SET_STATISTIC_DASHBOARD_LOADING, SET_STATISTICS_FILTER, SET_STATISTICS_LOADING,
    SHOW_DETAIL_LOADING, SHOW_EXPORT_STATISTICS_LOADING,
    STATISTICS_TABLE_TOGGLE, UPDATE_FILES_HISTORY, SET_STATISTICS_UI_FILTERS
} from "../types/typesStatisticsList";
import {GET_AUDIO_URL} from "../types/typesMonitoringList";
import {UPDATE_STATISTIC_FILTER} from "../types/typesCallsStatisticsList";


const initialState = {
    statisticsTableToggle: 'table1',
    selectedStatisticId: null,
    clearFilters: {
        userName: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        aNumber: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        ani: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        ownerUserName: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        ownerType: {value: null, matchMode: FilterMatchMode.IN},
        fullName: {value: null, matchMode: FilterMatchMode.IN},
        campaignFullName: {value: null, matchMode: FilterMatchMode.IN},
        branchId: {value: null, matchMode: FilterMatchMode.IN},
        queueFullName: {value: null, matchMode: FilterMatchMode.IN},
        status: {value: null, matchMode: FilterMatchMode.IN},
        callResetName: {value: null, matchMode: FilterMatchMode.IN},
        forcedClosing: {value: null, matchMode: FilterMatchMode.IN},
        callType: {value: null, matchMode: FilterMatchMode.IN},
        direction: {value: null, matchMode: FilterMatchMode.IN},
        campaignId: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        start: {value: null, matchMode: FilterMatchMode.IN},
        fullCallDuration: {value: null, matchMode: FilterMatchMode.IN},
        duration: {value: null, matchMode: FilterMatchMode.IN},
        reactionClient: {value: null, matchMode: FilterMatchMode.IN},
        reactionOperator: {value: null, matchMode: FilterMatchMode.IN},
        end: {value: null, matchMode: FilterMatchMode.IN},
    },
    statisticsList: [],
    campaignListName: [],
    checkUserForBan: false,
    pagination: {
        hasNext: 0,
        pageNumber: 0,
    },
    paginationPage: 1,
    paginationSize: 10,
    paginationFiles: {
        hasNext: 0,
        pageNumber: 0,
    },
    paginationFilesPage: 1,
    paginationFilesSize: 10,
    pageFilesChanged: false,
    statisticData: {
        duration: null,
        phoneNo: null,
        contactName: null,
        description: null,
        url: null,
        end: null,
        id: null,
        campaignId: null,
        campaignName: null,
        nameFrom: null,
        nameTo: null,
        status: null,
        typeChannel: null,
        start: null,
        direction: null,
        isDeclined: false,
        username: null,
        hasDetails: false,
        sessionId: null,
        amdHangup: null,
        callReset: null,
        evaluationScore: null,
        evaluationUserName: null,
        evaluationDate: null,
        audioControlId: null,
        audioControlName: null,
        manualEvaluation: null,
        aiEvaluation: null,
        transcription: null,
    },
    audioUrl: null,
    audioUrlLoading: false,
    audioUrlUploadLoading: false,
    loading: false,
    exportLoading: false,
    detailsLoading: false,
    sipDetailsLoading: false,
    error: false,
    errorUpdate: false,
    errorMessage: null,
    errorField: null,
    errorFields: null,
    pageChanged: false,
    statusDictionary: null,
    callResetDictionary: null,
    forcedClosingDictionary: null,
    statisticFilterData: null,
    filesHistoryLoader: false,
    filesHistory: null,
    statisticDashboard: null as any,
    statisticDashboardLoading: false,
    ratedQuestionnaires: [] as {
        id: number;
        name: string;
        status: number | null;
        statusLabel: string;
        statusBadgeClassName: string;
        searchLabel: string;
        score: number | null;
        isManual: boolean | null;
        userFullName: string | null;
        dateTimeEnd: string | null;
    }[],
}

export const StatisticsListReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case STATISTICS_TABLE_TOGGLE:
            return {...state, statisticsTableToggle: action.payload}
        case SELECTED_STATISTICS_ID:
            return {...state, selectedStatisticId: action.payload}
        case CLEAR_STATISTICS_FILTERS:
            return {
                ...state, clearFilters: {
                    userName: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    ani: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    aNumber: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    ownerUserName: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    ownerType: {value: null, matchMode: FilterMatchMode.IN},                    nameTo: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    fullName: {value: null, matchMode: FilterMatchMode.IN},
                    campaignFullName: {value: null, matchMode: FilterMatchMode.IN},
                    branchId: {value: null, matchMode: FilterMatchMode.IN},
                    queueFullName: {value: null, matchMode: FilterMatchMode.IN},
                    status: {value: null, matchMode: FilterMatchMode.IN},
                    callResetName: {value: null, matchMode: FilterMatchMode.IN},
                    forcedClosing: {value: null, matchMode: FilterMatchMode.IN},
                    callType: {value: null, matchMode: FilterMatchMode.IN},
                    direction: {value: null, matchMode: FilterMatchMode.IN},
                    campaignId: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    start: {value: null, matchMode: FilterMatchMode.IN},
                    fullCallDuration: {value: null, matchMode: FilterMatchMode.IN},
                    duration: {value: null, matchMode: FilterMatchMode.IN},
                    reactionClient: {value: null, matchMode: FilterMatchMode.IN},
                    reactionOperator: {value: null, matchMode: FilterMatchMode.IN},
                    end: {value: null, matchMode: FilterMatchMode.IN}
                }
            }
        case GET_STATISTICS:
            return {...state, statisticsList: action.payload}
        case GET_STATISTICS_PAGINATION:
            return {...state, pagination: {hasNext: action.payload.hasNext, pageNumber: action.payload.pageNumber}}
        case SET_CURRENT_STATISTICS_PAGE:
            return {...state, paginationPage: action.payload}
        case SET_CURRENT_STATISTICS_SIZE:
            return {...state, paginationSize: action.payload}
        case GET_STATISTICS_FILES_PAGINATION:
            return {...state, paginationFiles: {hasNext: action.payload.hasNext, pageNumber: action.payload.pageNumber}}
        case SET_CURRENT_STATISTICS_FILES_PAGE:
            return {...state, paginationFilesPage: action.payload}
        case SET_CURRENT_STATISTICS_FILES_SIZE:
            return {...state, paginationFilesSize: action.payload}
        case GET_STATISTIC:
            return {...state, statisticData: action.payload}
        case SET_STATISTICS_LOADING:
            return {...state, loading: action.payload}
        case HIDE_LOADER:
            return {...state, loading: false}
        case INITIAL_STATISTICS_DATA:
            return {...state, statisticData: initialState.statisticData, ratedQuestionnaires: []}
        case SET_RATED_QUESTIONNAIRES:
            return {...state, ratedQuestionnaires: action.payload}
        case CLEAR_ALL_STATES:
            return initialState
        case SHOW_DETAIL_LOADING:
            return {...state, detailsLoading: action.payload}
        case SHOW_EXPORT_STATISTICS_LOADING:
            return {...state, exportLoading: action.payload}
        case GET_AUDIO_URL:
            return {...state, audioUrl: action.payload}
        case AUDIO_LOADING:
            return {...state, audioUrlLoading: action.payload}
        case UPLOAD_AUDIO_LOADING:
            return {...state, audioUrlUploadLoading: action.payload}
        case SET_FIRST_PAGE:
            return {...state, pageChanged: !state.pageChanged}
        case SET_STATISTICS_FILTER:
            return {...state, statisticFilterData: action.payload}
        case GET_STATISTIC_DASHBOARD:
            return {...state, statisticDashboard: action.payload}
        case SET_STATISTIC_DASHBOARD_LOADING:
            return {...state, statisticDashboardLoading: action.payload}
        case SET_FILES_HISTORY_LOADER:
            return {...state, filesHistoryLoader: action.payload}
        case GET_FILES_HISTORY:
            return {...state, filesHistory: action.payload};
        case UPDATE_FILES_HISTORY:
            return {
                ...state,
                filesHistory: [action.payload, ...(state.filesHistory || [])]
            };
        case UPDATE_STATISTIC_FILTER:
            const { field, value } = action.payload;
            // @ts-ignore
            const currentFilter = state.clearFilters[field];

            if (!currentFilter) return state;

            let updatedField;

            if ('constraints' in currentFilter) {
                updatedField = {
                    ...currentFilter,
                    constraints: [
                        {
                            ...currentFilter.constraints[0],
                            value: value
                        }
                    ]
                };
            } else {
                updatedField = {
                    ...currentFilter,
                    value: value
                };
            }

            return {
                ...state,
                clearFilters: {
                    ...state.clearFilters,
                    [field]: updatedField
                }
            };
        case SET_STATISTICS_UI_FILTERS: {
            const nextFilters = { ...state.clearFilters };
            Object.entries(action.payload || {}).forEach(([filterField, filterValue]) => {
                // @ts-ignore
                const existingFilter = nextFilters[filterField];
                if (!existingFilter) return;
                if ('constraints' in existingFilter) {
                    // @ts-ignore
                    nextFilters[filterField] = {
                        ...existingFilter,
                        constraints: [
                            {
                                ...existingFilter.constraints[0],
                                value: filterValue
                            }
                        ]
                    };
                } else {
                    // @ts-ignore
                    nextFilters[filterField] = {
                        ...existingFilter,
                        value: filterValue
                    };
                }
            });
            return {
                ...state,
                clearFilters: nextFilters
            };
        }
        default:
            return state
    }
}
